import { Container, Typography } from '@mui/material'
import styled from 'styled-components'

const NotFoundContainer = styled(Container)`
    display: flex;
    justify-content: center;

    margin-top: 50px;
`

export function NotFoundRoute() {
    return (
        <NotFoundContainer>
            <Typography variant="h3">Hier gibt's nichts zu sehen 🤷</Typography>
        </NotFoundContainer>
    )
}
